export default __webpack_public_path__ + "static/urs-401baa1effdab1e4ca3b7b858ad5506c.png";